import { render, staticRenderFns } from "./ProjectionVarietyChart.vue?vue&type=template&id=0903a79c&"
import script from "./ProjectionVarietyChart.vue?vue&type=script&lang=js&"
export * from "./ProjectionVarietyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports